import { View, Text, StyleSheet, Image } from '@react-pdf/renderer'
import { PDFReportFeatureProps } from '..'
import { toTitleCase } from '@/lib/utils'
import { pdfFontSize, pdfPadding } from '../_data/style-define'

const styles = StyleSheet.create({
  floodSection: {},
  floodTitle: {
    fontWeight: 'bold',
    color: '#00B5A3',
    fontSize: pdfFontSize.title,
    marginBottom: pdfPadding.small,
  },
  floodImage: {
    width: '100%',
    height: 200, // Taller than regular images to show more map detail
    marginBottom: pdfPadding.medium,
    marginTop: pdfPadding.medium,
    objectFit: 'cover',
  },
  floodTable: {
    width: '100%',
    marginBottom: pdfPadding.small,
  },
  floodTableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    paddingVertical: pdfPadding.small,
    minHeight: pdfPadding.medium, // Ensures consistent height for rows
  },
  floodTableCell: {
    flex: 1,
    fontSize: pdfFontSize.text,
    paddingRight: pdfPadding.small,
  },
  floodTableCellRight: {
    flex: 2, // Gives more space for longer descriptions
    fontSize: pdfFontSize.text,
    textAlign: 'left',
  },
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: pdfPadding.medium,
    marginTop: pdfPadding.small,
  },
  gridItem: {
    width: '48%',
  },
  gridItemFullWidth: {
    width: '100%',
  },
})

export default function FloodRiskSection({
  data,
  ability,
  type,
}: PDFReportFeatureProps) {
  if (!ability.floodMaps) return null

  if (type === 'parcel') {
    return (
      <View style={styles.floodSection} break>
        <Text style={styles.floodTitle}>Flood Risk</Text>
        <Image
          src={data.floodRiskImage}
          style={styles.floodImage}
        />

        <View style={styles.floodTable}>
          {data?.floodRisk?.features?.map((feature: any, index: number) => (
            <View
              style={{
                marginBottom:
                  index === data.floodRisk.features.length - 1
                    ? 0
                    : pdfPadding.small,
              }}
              key={feature.id}
            >
              <View style={styles.floodTableRow}>
                <Text style={styles.floodTableCell}>Symbology</Text>
                <Text style={styles.floodTableCellRight}>
                  {toTitleCase(feature.properties.fld_zone)}
                </Text>
              </View>
              <View style={styles.floodTableRow}>
                <Text style={styles.floodTableCell}>Flood Zone Subtype</Text>
                <Text style={styles.floodTableCellRight}>
                  {toTitleCase(feature.properties.zone_subty)}
                </Text>
              </View>
              <View style={[styles.floodTableRow, { borderBottomWidth: 0 }]}>
                <Text style={styles.floodTableCell}>Zone Description</Text>
                <Text style={styles.floodTableCellRight}>
                  {toTitleCase(feature.properties.DESC)}
                </Text>
              </View>
            </View>
          ))}
        </View>
      </View>
    )
  }

  return (
    <View style={styles.floodSection} break>
      <Text style={styles.floodTitle}>Flood Risk</Text>
      {ability.apnDisplay && (
        <View
          style={{
            gap: 4,
          }}
        >
          <Text
            style={{
              fontSize: pdfFontSize.subtitle,
              fontWeight: 'bold',
              color: '#00B5A3',
            }}
          >
            For APN(s):{' '}
            <Text
              style={{
                fontSize: pdfFontSize.subtitle,
                fontWeight: 'normal',
                color: '#00B5A3',
              }}
            >
              {data.floodRiskData.apn.toString().replaceAll(',', ', ')}
            </Text>
          </Text>
        </View>
      )}
      <Image
        src={data.floodRiskImage}
        style={styles.floodImage}
      />

      <View style={styles.floodTable}>
        {data?.floodRiskData?.features.map((feature: any, index: number) => {
          return (
            <View
              style={{
                marginBottom:
                  index === data?.floodRiskData.features.length - 1
                    ? 0
                    : pdfPadding.small,
              }}
              key={feature.id}
            >
              <View style={styles.floodTableRow}>
                <Text style={styles.floodTableCell}>Symbology</Text>
                <Text style={styles.floodTableCellRight}>
                  {toTitleCase(feature.properties.fld_zone)}
                </Text>
              </View>
              <View style={styles.floodTableRow}>
                <Text style={styles.floodTableCell}>Flood Zone Subtype</Text>
                <Text style={styles.floodTableCellRight}>
                  {toTitleCase(feature.properties.zone_subty)}
                </Text>
              </View>
              <View style={[styles.floodTableRow, { borderBottomWidth: 0 }]}>
                <Text style={styles.floodTableCell}>Zone Description</Text>
                <Text style={styles.floodTableCellRight}>
                  {toTitleCase(feature.properties.DESC)}
                </Text>
              </View>
            </View>
          )
        })}
      </View>
    </View>
  )
}
